import React from 'react';
import { PartnerTable } from 'components';

export const Partners = () => {
	return <PartnerTable />;
};